import { Box, CircularProgress, Paper, Typography } from '@mui/material';

// Show pending files in a modern, clean list above the main table
const PendingFilesList = ({ pendingFiles }) => {
	if (pendingFiles.length === 0) return null;

	return (
		<Paper
			elevation={0}
			sx={{
				mt: 2,
				mb: 3,
				p: 2,
				border: '1px solid #e0e0e0',
				borderRadius: 1,
				backgroundColor: '#f5f9ff', // Light blue background
			}}
		>
			<Typography variant='subtitle1' sx={{ mb: 2, fontWeight: 500 }}>
				Files being processed
			</Typography>

			{pendingFiles.map((file, index) => {
				// Calculate time elapsed since upload started
				const now = new Date();
				const elapsed = Math.floor(
					(now - new Date(file.uploadStartTime)) / 1000
				);
				const timeDisplay =
					elapsed < 60
						? `${elapsed}s`
						: `${Math.floor(elapsed / 60)}m ${elapsed % 60}s`;

				return (
					<Box
						key={index}
						sx={{
							display: 'flex',
							alignItems: 'center',
							mb: index < pendingFiles.length - 1 ? 2 : 0,
							p: 1,
							borderRadius: 1,
							backgroundColor: 'rgba(255, 255, 255, 0.7)',
						}}
					>
						<CircularProgress size={20} sx={{ mr: 2 }} />
						<Box sx={{ flexGrow: 1 }}>
							<Typography variant='body1' sx={{ fontWeight: 500 }}>
								{file.fileName}
							</Typography>
							<Typography variant='caption' color='text.secondary'>
								Target: {file.object} • Processing for {timeDisplay}
							</Typography>
						</Box>
					</Box>
				);
			})}
		</Paper>
	);
};

export default PendingFilesList;
